import React from 'react';

/**
 * TopList component for displaying top items with a fixed height and scrollable content
 * @param {Object} props Component props
 * @param {string} props.title Title of the list
 * @param {Array} props.items Array of items to display
 * @param {string} props.labelKey Key to use for item label
 * @param {string} props.valueKey Key to use for item value
 * @param {function} props.formatValue Optional function to format the value
 */
const TopList = ({ title, items = [], labelKey, valueKey, formatValue }) => {
  // Default format function if none provided
  const defaultFormat = (value) => value?.toFixed(2);
  const formatValueFn = formatValue || defaultFormat;

  return (
    <div className="dash-card sorting-card">
      <div className="dash-card-heading mb-2">
        <h2 className="dash-card-title">{title}</h2>
      </div>
      {items.length > 0 ? (
        <div className="top-items" style={{ maxHeight: '180px', overflowY: 'auto' }}>
          {items.map((item, i) => (
            <div className="top-item" key={i}>
              <h6>{i + 1}. {item[labelKey]}</h6>
              <span>${formatValueFn(item[valueKey])}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-data no-data-100">No Data</div>
      )}
    </div>
  );
};

export default TopList; 